import execute from './callApi_mysql';
import ApiRequestError from '../components/ApiRequestError';

export const CALL_API = Symbol('Call API');

export default store => next => action => {
  const apiAction = action[CALL_API];

  // So the middleware doesn't get applied to every single action
  if (typeof apiAction === 'undefined') {
    return next(action);
  }

  let {
    type,
    endpoint,
    authenticated,
    config,
    request = () => {},
    success = r => r.json,
    failure = r => alert(r.message)
  } = apiAction;

  const [requestType, successType, errorType] = [
    '_REQUEST',
    '_SUCCESS',
    '_FAILURE'
  ].map(v => type + v);

  // Passing the authenticated boolean back in our data will let us distinguish between normal and secret quotes
  request();
  next({
    ...action,
    type: requestType
  });

  return execute(endpoint, authenticated, config)
  .then(
    result => {
      const response = success(result);

      next({
        ...action,
        type: successType,
        response
      });

      return response;
    },
    result => {
      if (result instanceof ApiRequestError) {
        const response = failure(result.result);

        next({
          ...action,
          type: errorType,
          response
        });

        return Promise.reject(result);
      } else if (!result.response) {
        const response = failure(result);

        next({
          ...action,
          type: errorType,
          response
        });
        console.error(1, result, 2, response);
  
        return Promise.reject(new ApiRequestError(0, [{
          type: "GENERIC_ERROR",
          value: result.message
        }], result));
      } else {
        const response = failure(result);

        next({
          ...action,
          type: errorType,
          response
        });
        console.log(1, result, 2, response);
  
        return Promise.reject(new ApiRequestError(result.response.status, response.error_messages, result));
      }
    }
  );
};



// WEBPACK FOOTER //
// ./src/middlewares/api.js